import {
  SELECT_TRANSACTION_TYPE,
  OPEN_SOLD_OUT_MODAL,
  CLOSE_SOLD_OUT_MODAL,
  OPEN_PARTY_AVAILABLE_MODAL,
  CLOSE_PARTY_AVAILABLE_MODAL,
  OPEN_ZOOM_MODAL,
  CLOSE_ZOOM_MODAL,
  ZOOM_IN,
  ZOOM_OUT,
  DISPLAY_NEXT_IMAGE,
  DISPLAY_PREVIOUS_IMAGE,
  SELECT_ZOOM_THUMBNAIL,
} from '../actions/productDetailPage'

import {PRODUCT_OK, RESET_TO_INITIAL_STATE} from '../actions/product'

const initialState = {
  callback: null,
  soldOutModalIsOpen: false,
  partyAvailableModalIsOpen: false,
  zoomModalIsOpen: false,
  currentZoomImageIndex: null,
  isZoomedIn: true,
  selectedZoomThumbnail: null,
  manuallySelectedTransactionType: null,
}

export default function reducer(state = initialState, action) {
  let newState

  switch (action.type) {
    case OPEN_SOLD_OUT_MODAL:
      newState = {soldOutModalIsOpen: true}
      break

    case CLOSE_SOLD_OUT_MODAL:
      newState = {soldOutModalIsOpen: false}
      break

    case OPEN_PARTY_AVAILABLE_MODAL:
      newState = {
        partyAvailableModalIsOpen: true,
        callBack: action.callback,
      }
      break

    case CLOSE_PARTY_AVAILABLE_MODAL:
      newState = {partyAvailableModalIsOpen: false}
      break

    case OPEN_ZOOM_MODAL:
      newState = {zoomModalIsOpen: true}
      break

    case CLOSE_ZOOM_MODAL:
      newState = {zoomModalIsOpen: false}
      break

    case ZOOM_IN:
      newState = {isZoomedIn: true}
      break

    case ZOOM_OUT:
      newState = {isZoomedIn: false}
      break

    case DISPLAY_NEXT_IMAGE:
      newState = {currentZoomImageIndex: action.index}
      break

    case DISPLAY_PREVIOUS_IMAGE:
      newState = {currentZoomImageIndex: action.index}
      break

    case RESET_TO_INITIAL_STATE:
      newState = {manuallySelectedTransactionType: null}
      break

    case SELECT_TRANSACTION_TYPE:
      newState = {manuallySelectedTransactionType: action.payload.transactionType}
      break

    case SELECT_ZOOM_THUMBNAIL:
      newState = {currentZoomImageIndex: action.index}
      break

    case PRODUCT_OK:
      newState = {
        currentZoomImageIndex: 0,
      }
      break

    default:
      break
  }

  return newState ? Object.assign({}, state, newState) : state
}
